/*
 * Copyright (C) 2026 Nex4Nova (Geoblast group)
 * SPDX-License-Identifier: Proprietary
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);
